export const SOUND_URL = "/sound/notification.mp3";

export const DEFAULT_SOUND_OPTIONS = [
  { key: "default", label: "Default" },
  { key: "chime", label: "Chime" },
  { key: "bell", label: "Bell" },
  { key: "pop", label: "Pop" },
];

export const TRIGGER_ORDER = [
  "new_chat",
  "chat_assigned",
  "chat_message",
  "new_ticket",
  "ticket_assigned",
  "ticket_message",
  "ticket_status_changed",
  "kb_article_pending_review",
  "kb_article_published",
  "kb_feedback_received",
  "kb_feedback_assigned",
];

export const NOTIFICATION_EVENTS = [
  {
    key: "new_chat",
    title: "New chat",
    description: "New chat in one of your groups",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "chat_assigned",
    title: "Chat assigned",
    description: "Chat assigned to you or your team",
    defaults: { inApp: true, browser: true, email: false },
  },
  {
    key: "chat_message",
    title: "New chat message",
    description: "New message in assigned chat",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "new_ticket",
    title: "New ticket",
    description: "New ticket in one of your groups",
    defaults: { inApp: false, browser: false, email: false },
  },
  {
    key: "ticket_assigned",
    title: "Ticket assigned",
    description: "Ticket assigned to you or your team",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "ticket_message",
    title: "Ticket message",
    description: "New message in assigned ticket",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "ticket_status_changed",
    title: "Ticket solved",
    description: "Assigned ticket marked solved",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "kb_article_pending_review",
    title: "Article submitted",
    description: "KB article pending editor review",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "kb_article_published",
    title: "Article published",
    description: "KB article published",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "kb_feedback_received",
    title: "New comment",
    description: "New comment in feedback queue",
    defaults: { inApp: true, browser: false, email: false },
  },
  {
    key: "kb_feedback_assigned",
    title: "Comment assigned",
    description: "KB article comment assigned to you",
    defaults: { inApp: true, browser: false, email: false },
  },
];

const EVENT_DEFAULTS = NOTIFICATION_EVENTS.reduce((acc, event) => {
  acc[event.key] = { ...event.defaults };
  return acc;
}, {});

export function buildDefaultPreferences() {
  return { ...EVENT_DEFAULTS };
}

export function buildEventRows(triggerLabels = {}) {
  return TRIGGER_ORDER.map((key) => {
    const fallback = NOTIFICATION_EVENTS.find((event) => event.key === key);
    const labels = triggerLabels[key];
    return {
      key,
      title: labels?.label ?? fallback?.title ?? key,
      description: labels?.description ?? fallback?.description ?? "",
      defaults: fallback?.defaults ?? { inApp: false, browser: false, email: false },
    };
  });
}

export function getErrorMessage(payload) {
  if (!payload) return "Something went wrong";
  if (typeof payload === "string") return payload;
  return (
    payload.message ||
    payload.error ||
    (Array.isArray(payload.errors) && payload.errors[0]?.message) ||
    "Something went wrong"
  );
}
